<medrecord-auth-twofa-steps
  [step]="step$ | async"
  [codes]="codes$ | async"
  (nextStep)="nextStep()"
></medrecord-auth-twofa-steps>